import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../_actions/matchesActions";
import * as profileActions from "../../_actions/profileActions";
import * as appActions from "../../_actions/appActions";
import InfiniteScroll from "react-infinite-scroller";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import { confirmAlert } from "react-confirm-alert";
import getPendingInvitations from "../../_selectors/matchesSelectors/getPendingInvitations";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
class PendingInvitations extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getPendingInvitations
    } = this.props;
    updateHeader({
      title: "Pending Connect Invitations",
      description: "Invitations that you sent to members"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Pending Connect Invitations", link: "/search" }
    ]);
    getPendingInvitations();
  }
  componentWillUnmount() {
    const { clearMembers, clearPendingInvitations } = this.props;
    clearMembers();
    clearPendingInvitations();
  }
  cancel = profile => {
    const {
      toast,
      cancelInvitaion,
      clearPendingInvitations,
      getPendingInvitations
    } = this.props;
    const onError = error => {
      toast({ type: "error", message: error });
    };
    const onSuccess = () => {
      toast({
        type: "success",
        message: `Invitation to connect with ${profile.name} cancelled.`
      });
      clearPendingInvitations();
      getPendingInvitations();
    };
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You will no longer be able to chat with {profile.name}</p>
            <button onClick={onClose}>No</button>
            <button
              onClick={() => {
                cancelInvitaion({
                  profileId: profile.id,
                  onSuccess,
                  onError
                });
                onClose();
              }}
            >
              Yes, Cancel!
            </button>
          </div>
        );
      }
    });
  };
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <PageSubTitle center>
                <h3>No Invitations Sent</h3>
              </PageSubTitle>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer
                    user={result.profileId}
                    cancel
                    onCancel={this.cancel}
                  />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getPendingInvitations(state),
  lastResult: getMatchesLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getPendingInvitations: () => dispatch(matchesActions.getPendingInvitations()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearPendingInvitations: () =>
    dispatch(matchesActions.clearPendingInvitations()),
  cancelInvitaion: payload =>
    dispatch(profileActions.disconnectWithMember(payload)),
  toast: payload => dispatch(appActions.showToast(payload)),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, {
          type: matchesConstants.GET_PENDING_INVITATIONS
        })
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingInvitations);



// WEBPACK FOOTER //
// ./src/_components/PendingInvitations/index.js